import {
  Directive,
  ElementRef,
  inject,
  input,
  Renderer2,
  effect,
} from '@angular/core';
import { AvatarThemeColor } from '@progress/kendo-angular-layout';

/**
 * Kendo 25 dropped the status theme colors (info, success, warning, error)
 * from the Avatar. The app still uses them, so this sets the matching
 * `k-avatar-<color>` class itself; the status colors are styled in
 * `_overrides.scss`, the others by the Kendo theme.
 */
export type AvatarColor =
  | AvatarThemeColor
  | 'info'
  | 'success'
  | 'warning'
  | 'error';

@Directive({
  selector: 'kendo-avatar[ldmAvatarColor]',
  standalone: true,
})
export class AvatarColorDirective {
  readonly ldmAvatarColor = input.required<AvatarColor>();

  private readonly element = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(Renderer2);
  private current: string | undefined;

  constructor() {
    effect(() => {
      const next = `k-avatar-${this.ldmAvatarColor()}`;
      if (this.current) {
        this.renderer.removeClass(this.element.nativeElement, this.current);
      }
      this.renderer.addClass(this.element.nativeElement, next);
      this.current = next;
    });
  }
}
